function Unauthorized() {
    return <div>
        You are nout authorized to view this apge
    </div>
}

export default Unauthorized